import axios from "axios";
import { fetchAuthSession } from "aws-amplify/auth";
import { config } from "../config.js";

const instance = axios.create({
  baseURL: config.controlPlaneAPI,
});

instance.interceptors.request.use(async (axiosConfig) => {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  if (!token) throw new Error("No authentication token available");
  axiosConfig.headers.Authorization = `Bearer ${token}`;
  return axiosConfig;
});

/**
 * Convert a File object to a base64-encoded string.
 * @param {File} file
 * @returns {Promise<string>}
 */
function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      // result is a data URL like "data:<mime>;base64,<data>" — strip the prefix
      const base64 = reader.result.split(",")[1];
      resolve(base64);
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

/**
 * Submit user feedback. Optionally attaches a file.
 * @param {string} message - Required feedback message text
 * @param {File|null} file  - Optional file attachment (max 4 MB)
 * @returns {Promise<{message: string}>}
 */
export async function submitFeedback(message, file = null) {
  const payload = { message };

  if (file) {
    payload.filename = file.name;
    payload.content_type = file.type || "application/octet-stream";
    payload.file_base64 = await fileToBase64(file);
  }

  const res = await instance.post("/feedback", payload);
  return res.data;
}
